import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Collapse } from 'react-collapse';
import ArrowIcon from '../../../images/arrow.png';
import { setChoosedTemplateTags } from '../../../actions/folders';
import TemplateParamsFilters from './TemplateParamsFilters';
import { CATEGORY_INGREDIENTS, TEMPLATE_PARAMETERS_TAG } from '../../../constants/appConstants';

const FilterBlock = ({
  getTemplates,
  tags,
  setChoosedTemplateTags,
  searchNameTemplate,
  filterBlockWidth,
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const open = () => {
    setIsOpened(!isOpened);
  };

  let categoryIngredientsTags = [];
  if (tags && tags.length) {
    categoryIngredientsTags = tags.filter((tag) => tag.category_id === CATEGORY_INGREDIENTS);
  }
  let templateParamTags = [];
  if (tags && tags.length) {
    templateParamTags = tags.filter((tag) => tag.category_id === TEMPLATE_PARAMETERS_TAG);
  }

  const FilterWrapper = styled.div`
    width: ${filterBlockWidth};
    margin: 15px auto;
    box-sizing: border-box;
    border: 1px solid #c1c1c1;
    border-radius: 5px;
    background: #fff;
    @media (max-width: 992px) {
      width: 75%;
    }
  `;

  return (
    <FilterWrapper>
      <Title onClick={open}>
        Фильтрация
        <Img src={ArrowIcon} alt="arrow" isOpened={isOpened} />
      </Title>
      <Collapse isOpened={isOpened}>
        <TemplateParamsFilters
          getTemplates={getTemplates}
          setChoosedTemplateTags={setChoosedTemplateTags}
          searchNameTemplate={searchNameTemplate}
          categoryIngredientsTags={categoryIngredientsTags}
          templateParamTags={templateParamTags}
          setIsOpened={setIsOpened}
          isOpened={isOpened}
        />
      </Collapse>
    </FilterWrapper>
  );
};

const mapStateToProps = (state) => {
  const { isOpenedDishTags, isOpenedTemplateTags } = state.folders;
  const { searchNameTemplate } = state.template;

  return {
    searchNameTemplate,
    isOpenedDishTags,
    isOpenedTemplateTags,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setChoosedTemplateTags: (tags) => {
      dispatch(setChoosedTemplateTags(tags));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBlock);

const Title = styled.p`
  height: 40px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  line-height: 40px;
  cursor: pointer;
  background: #157aac;
  color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  &:hover {
    background: #4f93c3;
    border: 1px solid #000542;
  }
`;

const Img = styled.img`
  margin-left: 25px;
  width: 25px;
  height: 25px;
  transition: 0.3s;
  transform: ${(props) => (props.isOpened ? 'rotate(180deg)' : '')};
`;



// WEBPACK FOOTER //
// ./src/Components/Templates/TemplatesList/FilterBlock.jsx